const Header = () => {
    return(
        <>
                
    <div className="header header-transparent-bg section-fluid">
        
        <div className="header-wrapper">
            <div className="header-sticky">
                <div className="container-fluid">
                    <div className="row align-items-center">

                        

                    </div>
                </div>
            </div>
        </div>
        

        
        

    </div>        

        </>
    )
}

export default Header